export function promiseRequestAnimationFrame(): PromiseLike<number> {
  return new Promise(resolve => window.requestAnimationFrame(resolve))
}
